<head>
    <!-- Google Tag Manager -->
  
    <script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>
  
    <!-- End Google Tag Manager -->
  </head>
  <!-- Google Tag Manager (noscript) -->
  
  <noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0" style="display:none;visibility:hidden"></iframe>
  </noscript>
  
  <!-- End Google Tag Manager (noscript) -->

<br />
<div class="row" style="text-align: center; margin: auto;">
    <div class="col">
        <div class="card">
            <div class="card-body" style="margin: auto">
                <div class="card-title">Regulated Trading Partners!</div>
                <p class="card-text">
                    <a href="https://www.fxcm.com/eu/about-fxcm/regulation/">
                        <img src="../assets/img/FXCM-1.jpg" />
                    </a>
                    <a href="https://www.etoro.com/customer-service/regulation-license/">
                        <img src="../assets/img/eToro.jpg" />
                    </a>
                    <a href="https://www.vantagefx.com/about-us/legal-licensing/regulation/">
                        <img src="../assets/img/Vantage.jpg" />
                    </a>
                </p>
            </div>
        </div>
    </div>
</div><br />

<div class="row" style="text-align: center; margin: auto;">
    <div class="col">
        <div class="card">
            <div class="card-body" style="margin: auto">
                <div class="card-title">How Algorithms Work!</div>
                <p class="card-text">
                    <tbody>
                        <tr>
                            <td>
                                <iframe src="https://drive.google.com/file/d/18C-K20BcYRUZ4dibPVp3pId5cGBq-Cf5/preview"
                                    width="640" height="480" allow="autoplay"></iframe>
                            </td>
                        </tr>
                    </tbody>
                </p>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card">
            <div class="card-body" style="margin: auto">
                <div class="card-title">The Midas Formula!</div>
                <p class="card-text">
                    <tbody>
                        <tr>
                            <td>
                                <iframe src="https://drive.google.com/file/d/1If51do7DaEALEuPGyxVYm1R3F5zzFr3f/preview"
                                    width="640" height="480" allow="autoplay"></iframe>
                            </td>
                        </tr>
                    </tbody>
                </p>
            </div>
        </div>
    </div>
</div><br />

<div class="row" style="text-align: center; margin: auto;">
    <div class="col">
        <div class="card">
            <div class="card-body" style="margin: auto">
                <div class="card-title"><img src="../assets/img/Vantage.jpg" height="50" width="100" /></div>
                <p class="card-text">
                    <tbody>
                        <tr>
                            <td>
                                Algo 01 - Launched Jan 2021
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://drive.google.com/file/d/1-nnIgZ5XpINX_-kPnKlaFNfRI_EHRNu7/view">Trading
                                    Account - Trend Charting</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://drive.google.com/file/d/1tixGWiNk2JkBYiBW5r30DgLScfrxAeYn/view">Trading
                                    Account - Data Acquisition</a>
                            </td>

                        </tr>
                        <tr>
                            <td>
                                <a href="https://drive.google.com/file/d/1cC0OSTzW37Ux2qw2zRxT6Qmkt3lJpVvl/view">Trading
                                    Account - Data Analysis</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a
                                    href="https://drive.google.com/file/d/1UDxsUblZuiOtp5NhDP9d9vQVOn57OrLw/view">Portfolio</a>
                            </td>
                        </tr>
                    </tbody>
                </p>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card">
            <div class="card-body" style="margin: auto">
                <div class="card-title"><img src="../assets/img/FXCM-1.jpg" height="50" width="100"></div>
                <p class="card-text">
                    <tbody>
                        <tr>
                            <td>
                                Algo 03 - Launched Jan 2021
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://drive.google.com/file/d/1znpQ4D7ZBpjENRlqplsFMB4IMZGto7HT/view">Trading
                                    Account - Trend Charting</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://drive.google.com/file/d/1jKZVI6OPRgUTNpIAPoD478j9THC7hk6x/view">Trading
                                    Account - Data Acquisition</a>
                            </td>

                        </tr>
                        <tr>
                            <td>
                                <a href="https://drive.google.com/file/d/10Ge7Ngafg2UShfaNi6Hojz0HXodTIH_P/view">Trading
                                    Account - Data Analysis</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a
                                    href="https://drive.google.com/file/d/1UDxsUblZuiOtp5NhDP9d9vQVOn57OrLw/view">Portfolio</a>
                            </td>
                        </tr>
                    </tbody>
                </p>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card">
            <div class="card-body" style="margin: auto">
                <div class="card-title"><img src="../assets/img/eToro.jpg" height="50" width="100"></div>
                <p class="card-text">
                    <tbody>
                        <tr>
                            <td>
                                Algo 02 - Launched Jan 2021
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://drive.google.com/file/d/1dzgNVrsfDzTaVQHvWKqpIDWxeXxtzw3e/view">Trading
                                    Account - Trend Charting</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://www.thecosmos.website/Reports-Algo02-Acquisition.pdf">Trading Account -
                                    Data Acquisition</a>
                            </td>

                        </tr>
                        <tr>
                            <td>
                                <a href="thecosmos.website/Reports-Algo02-Analysis.pdf">Trading Account - Data
                                    Analysis</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a
                                    href="https://drive.google.com/file/d/1UDxsUblZuiOtp5NhDP9d9vQVOn57OrLw/view">Portfolio</a>
                            </td>
                        </tr>
                    </tbody>
                </p>
            </div>
        </div>
    </div>
</div><br />

<div class="row" style="text-align: center; margin: auto;">
    <div class="col">
        <div class="card">
            <div class="card-body" style="margin: auto">
                <div class="card-title">
                    Fund Manager - Formal Documents</div>
                <p class="card-text">
                    <tbody>
                        <tr>
                            <td>
                                <a
                                    href="https://drive.google.com/drive/folders/1O_Gzz_cl1zBGWATuMqXbs80wwQJ3SaHl">Registration</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://core.cro.ie/e-commerce/company/667079">Search</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a
                                    href="https://drive.google.com/drive/folders/1fk_BVwcJFp4V7_Wk2W5VgKzbsbHLw3cW">Taxation</a>
                            </td>

                        </tr>
                        <tr>
                            <td>
                                <a
                                    href="https://drive.google.com/file/d/1-DWQPlDKbVIaGVX7qZiNG3EkoR4dsQzc/view">Banks</a>
                            </td>
                        </tr>
                    </tbody>
                </p>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card">
            <div class="card-body" style="margin: auto">
                <div class="card-title">Overview - Documents - (Development Documents - Password Protected)</div>
                <p class="card-text">
                    <tbody>
                        <tr>
                            <td>
                                <a href="https://drive.google.com/file/d/1Kz-JjYTiejgg_hngZD1QqeSJXCmaXv5Y/view">Portfolio
                                    Protocol</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://drive.google.com/file/d/1JnzafjPJKNmQUa1rQU7jYtIVqWFrqSjj/view">Development
                                    Algorithm 03</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://drive.google.com/file/d/1yiHwGLxj7XzEZ42DGX9zorO_X8S0OccO/view">Development
                                    Algorithm 02</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="https://drive.google.com/file/d/17GjzewFdSUDLbLDSIjerV9u1-L9wjsph/view">Development
                                    Algorithm 01</a>
                            </td>
                        </tr>
                    </tbody>
                </p>
            </div>
        </div>
    </div>
</div><br />